import { DispatchNote, Invoice } from '@/types/order';
import { http } from './http.service';
import { PDFRequest, PrintContract } from '@/types/pdf';
import { DOMAIN } from '@/app/utils/constant';

class PdfService {
  printContract = async (data: PrintContract) => {
    const response = await http.post(`/service/pdf/print-contract`, data, {
      responseType: 'blob',
    });
    return response;
  };

  downloadQuotation = async (data) => {
    const response = await http.post(`/service/pdf/cart`, data, {
      responseType: 'blob',
    });
    return response;
  };

  dispatchNote = async (data: PDFRequest<DispatchNote[]>) => {
    const response = await http.post(`/service/pdf/dispatch-note`, data, {
      responseType: 'blob',
    });
    return response;
  };

  invoice = async (data: PDFRequest<Invoice[]>) => {
    const response = await http.post(`/service/pdf/invoice`, data, {
      responseType: 'blob',
    });
    return response;
  };
  paymentInvoice = async (data) => {
    const response = await http.post(`/service/pdf/payment-invoice`, data, {
      responseType: 'blob',
    });
    return response;
  };
  qtpPDF = async (data) => {
    const response = await http.post(`${DOMAIN}/apac/service/admin/qtp`, data, {
      responseType: 'blob',
    });
    return response;
  };
}

export const pdfService = new PdfService();
